import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: false,
    inPersonStatus: null,
    audioFileId: null,
    categories: [],
    tempNotes: "",
    patients: [],
    newPatients: [],
    ArchivePatients: [],
    error: "",
    count: 0,
    selectedPatient: {},
    timeTracker: {},
    patientNotes: [],
    patientAppts: [],
    assessments: [],
    assessmentCompleted: 0,
    patientAssessments: [],
    assessmentType: { id: 3, value: "All" },
    selectedAssessment: null,
    downloadView: null,
    careGoal: [],
    careActivity: [],
    activityLogs: [],
    tracking: [],
    upcomingAppts: [],
    overviewAssessment: null,
    aiAnswers: [],
    viewAssessment: null,
    audios: [],
    aiHeaders: [],
    // Report of Findings cache
    reportOfFindingsCache: null,
    rofCacheTimestamp: null,
    rofGenerating: false,
    healthOverviewScale: [
        {
            assessment: "Depression",
            description: "N/A",
            score: 0,
            scale: 0,
            color: "#FF5C00",
            mcqCode: 100450023,
        },
        {
            assessment: "Anxiety",
            description: "N/A",
            score: 0,
            scale: 0,
            color: "#FFD231",
            mcqCode: 100450024,
        },
        {
            assessment: "Self-Esteem",
            description: "N/A",
            score: 0,
            scale: 0,
            color: "#98CD6E",
            mcqCode: 100450026,
        },
        {
            assessment: "Stress",
            description: "N/A",
            score: 0,
            scale: 0,
            color: "#FF5C00",
            mcqCode: 100450025,
        },
    ],
    sdohData: [],
    careCallAssessments: [],
    latestBhnRecommendations: { assessmentName: "", recommendations: [] },
    careGoalData: null,
    timerPlaying: false,
    time: null,
    selectedAudio: {},
    isRecording: false,
    isPaused: false,
    mediaBlobUrl: null,
    selectedTab: 0,
    selectedPatientlevelTab: 0,
    notesType: {
        id: 0,
        value: "All",
    },
    searchFilter: {},
    filterData: {
        programDesc: null,
        smsc: null,
        timeSpent: null,
        receivedConsent: null,
        date: null,
        // sms: { id: 101300001, value: "Yes", desc: "1" },
    },
    patientTableDetails: { tab: 0, pageNo: 0 },
    patientCallSummaryTab: 0,
    patientListActiveTab: 0,
    completedCareCallAsssessment: false,
    showArchiveConfirmationModal: false,
    isSmsConsentPendingScreen: false,
    pageDetails: {
        pageNo: 0,
        pageSize: 10,
    },
    summaryStates: {
        selectedOrg: {
            organizationId: null,
            value: "",
        },
        selectedClinic: {
            clinicId: null,
            value: "",
        },
        // dates: {
        //   month:
        // },
        tableDetails: {
            page: 0,
            pageSize: 10,
        },
    },
    showHardAlert: false,
    isTimeTrackerForced: false,
    selectedCareCallTab: null,
    showRegenerateSummaryButton: false,
    newCareGoals: [],
    showNewCareGoalsAlert: false,
    rejectedReasons: null,
    docAssistConversation: [],
    completedAssessments: {},
    unseenNotes: false,
    appointmentCount: 0,
    selectedIntern: {
        userId: null,
        name: "",
        value: "",
    },
}

const patientSlice = createSlice({
    name: "patients",
    initialState,
    reducers: {
        updateShowRegenerateSummaryButton: (state, action) => {
            state.showRegenerateSummaryButton = action.payload
        },
        updateShowNewCareGoalsAlert: (state, action) => {
            state.showNewCareGoalsAlert = action.payload
        },
        setShowArchiveConfirmationModal: (state, action) => {
            state.showArchiveConfirmationModal = action.payload
        },
        fetchPatientsRequest: state => {
            state.loading = true
        },
        fetchPatientsSuccess: (state, action) => {
            state.patients = action.payload || []
        },
        fetchPatientsFailure: (state, action) => {
            state.loading = false
            state.patients = []
            state.error = action.payload
        },
        fetchNewPatientsRequest: state => {
            state.loading = true
        },
        fetchNewPatientsSuccess: (state, action) => {
            state.newPatients = action.payload || []
        },
        fetchNewPatientsFailure: (state, action) => {
            state.loading = false
            state.newPatients = []
            state.error = action.payload
        },
        fetchArchivePatientsRequest: state => {
            state.loading = true
        },
        fetchArchivePatientsSuccess: (state, action) => {
            state.ArchivePatients = action.payload || []
        },
        fetchArchivePatientsFailure: (state, action) => {
            state.loading = false
            state.ArchivePatients = []
            state.error = action.payload
        },
        updatePatientsCount: (state, action) => {
            state.count = action.payload
        },
        updateSelectedPatient: (state, action) => {
            console.log(action.payload, "sjflkdjlfs")
            state.assessmentCompleted = null
            // state.selectedPatientlevelTab = 0
            state.selectedPatient = action.payload
        },
        updateTimeTrackerDetails: (state, action) => {
            state.timeTracker = action.payload || {}
        },
        updatePatientNotes: (state, action) => {
            state.patientNotes = action.payload
        },
        showPatientAppointments: (state, action) => {
            state.patientAppts = action.payload
        },
        updateAssessments: (state, action) => {
            state.assessments = action.payload || []
        },
        updatePatientAssessments: (state, action) => {
            state.patientAssessments = action.payload
        },
        updateAssessmentCompleted: (state, action) => {
            state.assessmentCompleted = action.payload
        },
        updateSelectedAssessment: (state, action) => {
            console.log(action.payload, "lksjfsldjflkf")
            state.selectedAssessment = action.payload
        },
        careGoal: (state, action) => {
            state.careGoal = action.payload
        },
        updateCareGoalState: (state, action) => {
            state.careGoal = []
        },
        tracking: (state, action) => {
            state.tracking = action.payload
        },
        updateCareActivity: (state, action) => {
            state.careActivity = action.payload
        },
        updateActivityLogs: (state, action) => {
            state.activityLogs = action.payload
        },
        fetchUpcomingAppointments: (state, action) => {
            state.upcomingAppts = action.payload
        },
        updateOverviewAssessment: (state, action) => {
            console.log(action.payload, "This is executed")
            state.overviewAssessment = action.payload
        },
        fetchAianswers: (state, action) => {
            state.aiAnswers = action.payload
        },
        updateViewAssessment: (state, action) => {
            state.viewAssessment = action.payload
        },
        updateHealthOverviewScale: (state, action) => {
            state.healthOverviewScale = action.payload
        },
        updateSdohData: (state, action) => {
            state.sdohData = action.payload
        },
        updateCareCallAssessments: (state, action) => {
            state.careCallAssessments = action.payload
        },
        updateLatestBhnRecommendations: (state, action) => {
            state.latestBhnRecommendations = action.payload
        },
        updateCareGoalData: (state, action) => {
            state.careGoalData = action.payload
        },
        updateTimerPlaying: (state, action) => {
            console.log(action.payload, "sfjsldfjdslflfj")
            state.timerPlaying = action.payload
        },
        updateTime: (state, action) => {
            state.time = action.payload
        },
        updatedSelectedAudio: (state, action) => {
            state.selectedAudio = action.payload
        },
        updateAudios: (state, action) => {
            state.audios = action.payload || []
        },
        startRecording: (state, action) => {
            state.isRecording = true
            state.isPaused = false
        },
        stopRecording: (state, action) => {
            state.isRecording = false
            state.isPaused = false
            state.mediaBlobUrl = null
        },
        pauseRecording: (state, action) => {
            state.isPaused = true
        },
        resumeRecording: (state, action) => {
            state.isPaused = false
        },
        setMediaBlobUrl: (state, action) => {
            state.mediaBlobUrl = action.payload
        },
        updateDownloadView: (state, action) => {
            state.downloadView = action.payload
        },
        fetchAIHeaders: (state, action) => {
            state.aiHeaders = action.payload || []
        },
        updateAssessmentType: (state, action) => {
            state.assessmentType = action.payload
        },
        setTab: (state, action) => {
            state.selectedTab = action.payload
        },
        updateNotesType: (state, action) => {
            state.notesType = action.payload
        },
        updateFilterData: (state, action) => {
            state.filterData = action.payload
        },
        updateSearchFilter: (state, action) => {
            state.searchFilter = action.payload
        },
        updatePatientTableDetails: (state, action) => {
            state.patientTableDetails = action.payload
        },
        clearSearchFilter: (state, action) => {
            state.searchFilter = {}
        },
        clearFilterData: (state, action) => {
            state.filterData = {
                programDesc: null,
                smsc: null,
                timeSpent: null,
                receivedConsent: null,
                date: null,
                sms: { id: 101300001, value: "Yes", desc: "1" },
            }
        },
        updateSelectedPatientLevelTab: (state, action) => {
            state.selectedPatientlevelTab = action.payload
        },
        updatePatientCallSummaryTab: (state, action) => {
            state.patientCallSummaryTab = action.payload
        },
        updatePatientListActiveTab: (state, action) => {
            state.patientListActiveTab = action.payload
        },
        updateCompletedCareCallAssessment: state => {
            state.completedCareCallAsssessment =
                !state.completedCareCallAsssessment
        },
        updateIsSmsConsentPendingScreen: (state, action) => {
            state.isSmsConsentPendingScreen = action.payload
        },
        updatePageDetails: (state, action) => {
            state.pageDetails = action.payload
        },
        updateSummaryStates: (state, action) => {
            state.summaryStates = action.payload
        },
        updateHardAlert: (state, action) => {
            state.showHardAlert = action.payload
        },
        updateIsTimeTrackerForced: (state, action) => {
            state.isTimeTrackerForced = action.payload
        },
        updateInPersonStatus: (state, action) => {
            state.inPersonStatus = action.payload
        },
        setAudioFileId: (state, action) => {
            state.audioFileId = action.payload // Update the audioFileId
        },
        updateSelectedCareCallTab: (state, action) => {
            state.selectedCareCallTab = action.payload
        },
        updateNewCareGoals: (state, action) => {
            state.newCareGoals = action.payload
        },
        updateRejectedReasons: (state, action) => {
            state.rejectedReasons = action.payload
        },
        setDocAssistConversation: (state, action) => {
            state.docAssistConversation = action.payload
        },
        updateCompletedAssessments: (state, action) => {
            state.completedAssessments = action.payload
        },
        updateUnseenNotes: (state, action) => {
            state.unseenNotes = action.payload
        },
        updateAppointmentCount: (state, action) => {
            state.appointmentCount = action.payload
        },
        // Report of Findings cache actions
        setReportOfFindingsCache: (state, action) => {
            state.reportOfFindingsCache = action.payload
            state.rofCacheTimestamp = Date.now()
        },
        clearReportOfFindingsCache: (state) => {
            state.reportOfFindingsCache = null
            state.rofCacheTimestamp = null
        },
        setRofGenerating: (state, action) => {
            state.rofGenerating = action.payload
        },
        updateSelectedIntern: (state, action) => {
            state.selectedIntern = action.payload
        },
    },
})

export const {
    updateRejectedReasons,
    updateShowRegenerateSummaryButton,
    updateShowNewCareGoalsAlert,
    updateNewCareGoals,
    fetchNewPatientsFailure,
    fetchNewPatientsRequest,
    fetchNewPatientsSuccess,
    fetchArchivePatientsFailure,
    fetchArchivePatientsRequest,
    fetchArchivePatientsSuccess,
    fetchPatientsFailure,
    fetchPatientsSuccess,
    fetchPatientsRequest,
    updatePatientsCount,
    updateSelectedPatient,
    updatePatientNotes,
    showPatientAppointments,
    updateAssessments,
    updatePatientAssessments,
    updateAssessmentCompleted,
    updateSelectedAssessment,
    updateTimeTrackerDetails,
    careGoal,
    updateCareActivity,
    updateActivityLogs,
    tracking,
    fetchUpcomingAppointments,
    updateOverviewAssessment,
    fetchAianswers,
    updateViewAssessment,
    updateHealthOverviewScale,
    updateSdohData,
    updateCareCallAssessments,
    updateLatestBhnRecommendations,
    updateCareGoalData,
    updateTimerPlaying,
    updateTime,
    updateAudios,
    updatedSelectedAudio,
    startRecording,
    stopRecording,
    pauseRecording,
    resumeRecording,
    setMediaBlobUrl,
    updateDownloadView,
    fetchAIHeaders,
    updateAssessmentType,
    setTab,
    updateNotesType,
    updateFilterData,
    updateSearchFilter,
    updatePatientTableDetails,
    clearSearchFilter,
    clearFilterData,
    updateSelectedPatientLevelTab,
    updatePatientCallSummaryTab,
    updatePatientListActiveTab,
    updateCompletedCareCallAssessment,
    setShowArchiveConfirmationModal,
    updateCareGoalState,
    updateIsSmsConsentPendingScreen,
    updatePageDetails,
    updateSummaryStates,
    updateHardAlert,
    updateIsTimeTrackerForced,
    updateInPersonStatus,
    setAudioFileId,
    updateSelectedCareCallTab,
    setDocAssistConversation,
    updateCompletedAssessments,
    updateUnseenNotes,
    updateAppointmentCount,
    setReportOfFindingsCache,
    clearReportOfFindingsCache,
    setRofGenerating,
    updateSelectedIntern,
} = patientSlice.actions

export default patientSlice.reducer
